export default "__VITE_ASSET__BrVZJbJA__"